import React from 'react';
import { classNames, isFunction } from '@philips-internal/oswald-ui-utils';
import { ContextActionType } from '../../actions/context-action.js';
function ContextMenuItem(props) {
    const { action } = props;
    if (action.type === ContextActionType.SEPARATOR) {
        return (React.createElement("div", { className: "c-oswald-context-menu__separator" }));
    }
    const className = classNames({
        'c-oswald-context-menu__item': true,
        'c-oswald-context-menu__item--disabled': Boolean(action.disabled),
    });
    const onItemClick = () => {
        props.onClick();
        if (isFunction(action.callee)) {
            void action.callee();
        }
    };
    return (React.createElement("div", { className: className, onClick: onItemClick }, action.title));
}
export { ContextMenuItem, };
//# sourceMappingURL=context-menu-item.js.map